import React, { useRef, useState } from 'react';
import Select from 'react-select';
import clsx from 'clsx';

import { Driver, FocusedField, iOption, Truck } from '../../pages/Order/Scheduling';
import Input from '../../components/Input';

import './styles.scss';

type Selected = {
  value: string;
  label: string;
};
interface ModalNewLoadingProps {
  setDriverOptions: React.Dispatch<React.SetStateAction<iOption[]>>;
  handleClose(): void;
  handleChangeInputSelect(value: string, path: string, setOption: any): void;
  handleChangeOptionLicensePlate(option: iOption): void;
  handleChangeOptionDriver(option: iOption): void;
  handleChangeQuantity(event: React.ChangeEvent<HTMLInputElement>): void;
  handleExpirationDate(event: React.ChangeEvent<HTMLInputElement>): void;
  handleToggleFrelancerDriver(value: boolean): void;
  handleAddScheduling(): void;
  className: 'show' | string;
  isFreelancerDriver: boolean;
  selectedPlate: Selected;
  licensePlateOptions: iOption[];
  setLicensePlateOptions: React.Dispatch<React.SetStateAction<iOption[]>>;
  vehicleModel?: string;
  selectedDriver: Selected;
  driverOptions: iOption[];
  quantity: number;
  expirationDate: string;
  licensePlateValue: Truck;
  driverValue: Driver;
  setFocusedField: React.Dispatch<React.SetStateAction<FocusedField>>;
}

export function ModalNewLoading({
  className,
  handleClose,
  selectedPlate,
  licensePlateOptions,
  handleChangeInputSelect,
  setLicensePlateOptions,
  handleChangeOptionLicensePlate,
  handleToggleFrelancerDriver,
  vehicleModel,
  selectedDriver,
  driverOptions,
  setDriverOptions,
  handleChangeOptionDriver,
  handleChangeQuantity,
  quantity,
  handleAddScheduling,
  expirationDate,
  handleExpirationDate,
  isFreelancerDriver,
  licensePlateValue,
  driverValue,
  setFocusedField,
}: ModalNewLoadingProps) {
  const modalRef = useRef(null);

  const handleSubmit = () => {
    handleClose();

    if (!licensePlateValue.id || !driverValue.id || quantity === 0) return;
    handleAddScheduling();
  };

  const handleToggle = (value: boolean) => {
    handleToggleFrelancerDriver(value);
  };

  const handleOnBlur = () => {
    setFocusedField('');
  };

  return (
    <div id="myModal" className={`${className} modal modal-new-loading`} ref={modalRef}>
      <div className="modal-content">
        <div className="site-content cf">
          <div className="boxed-group dangerzone">
            <h3 className="modal-heading">
              NOVO CARREGAMENTO
              <span className="close" onClick={handleClose}>
                &times;
              </span>
            </h3>

            <div className="boxed-group-inner">
              <section>
                <form onSubmit={handleSubmit} autoComplete="off" className="form-new-loading">
                  <div className="form-group">
                    <fieldset className="new-loading-fieldset freedriver-switch-wrapper">
                      <Switch onChange={handleToggle} checked={isFreelancerDriver} />

                      <label>Autônomo</label>
                    </fieldset>

                    <div className="new-loading-fields">
                      <fieldset className="new-loading-fieldset">
                        <label>Veículo:</label>

                        <Select
                          className={clsx(['select-options'])}
                          value={selectedPlate}
                          options={licensePlateOptions}
                          onInputChange={(value) => handleChangeInputSelect(value, 'truck', setLicensePlateOptions)}
                          onChange={(option) => handleChangeOptionLicensePlate(option as iOption)}
                          onFocus={() => setFocusedField('vehiclePlate')}
                          onBlur={handleOnBlur}
                        />
                        {vehicleModel && <span style={{ fontSize: 14, marginLeft: 10, color: 'grey' }}>Modelo: {vehicleModel}</span>}
                      </fieldset>

                      <fieldset className="new-loading-fieldset">
                        <label>Motorista:</label>

                        <Select
                          className={clsx(['select-options', !isFreelancerDriver && 'disabled'])}
                          value={selectedDriver}
                          options={driverOptions}
                          onInputChange={(value) => handleChangeInputSelect(value, 'driver', setDriverOptions)}
                          onChange={(option) => handleChangeOptionDriver(option as iOption)}
                          isDisabled={!isFreelancerDriver}
                          onFocus={() => setFocusedField('driver')}
                          onBlur={handleOnBlur}
                        />

                        {/* {selectedPlate && !selectedDriver?.value &&  (
                          <Link to={`/caminhoes?plate=${selectedPlate.label}`} style={{ textDecoration: 'underline', color: '#000000', fontSize: '10px' }}>
                            Não encontrou o motorista? Verifique se há um motorista para esse caminhão.
                          </Link>
                        )} */}
                      </fieldset>

                      <Input
                        name="quantity"
                        placeholder="Quantidade"
                        onChange={(e) => handleChangeQuantity(e)}
                        value={quantity}
                        type="number"
                        label="Capacidade líquida:"
                        disabled={!isFreelancerDriver}
                        className={clsx(!isFreelancerDriver && 'disabled')}
                      />

                      <Input type="date" name="expirationDate" placeholder="Válido até" label="Válido até:" onChange={handleExpirationDate} value={expirationDate} />
                    </div>
                  </div>

                  <div className="form-actions-wrapper">
                    <button
                      type="button"
                      className="btn btn-add"
                      onClick={handleAddScheduling}
                      // {...(!licensePlateValue.id || !driverValue.id || quantity === 0 ? { disabled: true } : { disabled: false })}
                    >
                      Adicionar
                    </button>

                    <button type="button" className="btn btn-cancel" onClick={handleClose}>
                      Cancelar
                    </button>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Switch.tsx

interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false }) => {
  const [internalChecked, setInternalChecked] = useState(false);
  const isControlled = checked !== undefined;
  const currentChecked = isControlled ? checked : internalChecked;

  const handleToggle = () => {
    if (disabled) return;
    if (!isControlled) setInternalChecked(!currentChecked);
    onChange?.(!currentChecked);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={currentChecked}
      className={`switch ${currentChecked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={handleToggle}
      disabled={disabled}
    >
      <span className="switch-track">
        <span className="switch-thumb" />
      </span>
    </button>
  );
};
